/**
 * Portal Entry Point for Settings
 *
 * Registers the Settings shell page with the portal page registry.
 * This file is imported by the portal's virtual:portal-entries module.
 */

import { registerPage } from '@ja/portal/pageRegistry'

registerPage('settings', 'Base/SettingsShell', () => import('./Pages/SettingsShell.vue'))
